module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/teamRigthBg-b226af09699af21a3de4ed890efae257.png";